import { createFileRoute } from '@tanstack/react-router';
import { BillingSettingsPage } from '../components/settings/billing-settings-page.js';

export const Route = createFileRoute('/$workspaceSlug/settings/billing')({
  component: BillingSettingsPage,
});
